import React from 'react';
import './App.css';
import { useEffect } from 'react';
import Shell from './controls/Shell'
import './helpers/silentLogin';
import { ApplicationContextProvider } from './context/ApplicationContext';
import { Provider, themes } from '@stardust-ui/react'
import { logger } from './helpers/LoggerHelper';
import { resizeReporter } from './helpers/ResizeReporter';
import rtlDetect  from 'rtl-detect';
import { languageHelper } from './helpers/LanguageHelper';

const App: React.FC = () => {

  const [isRtlLanguage, setIsRtlLanguage] = React.useState(true);

  useEffect(() => {
    let language = languageHelper.GetCurrentLanguage();
    let direction = rtlDetect.getLangDir(language);
    let root = document.getElementById("htmlRoot");
    if (root)
    {
      root.dir = direction;
    }

    setIsRtlLanguage(direction === "rtl");

    logger.Log("Application mounting and subscribing to post messages");
    const handlePostMessage = (e: MessageEvent) => {
      if (e.data === "getHeight") {
        resizeReporter.report();
      }
    };

    window.addEventListener('message', handlePostMessage);
    return () => {
      logger.Log("removing the post messages handler");
      window.removeEventListener('message', handlePostMessage);
    }
  }, []);

  return (
    <div className="container">
      <ApplicationContextProvider>
      <Provider theme={themes.teams} rtl={isRtlLanguage} styles={{width: '100%'}}>
      <Shell />
      </Provider>
      </ApplicationContextProvider>
    </div>
  );
}

export default App;